import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const MyReviewIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "MyReviewIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M9.771 22H5.83301C4.40088 22 3.23535 20.8345 3.23535 19.4023V6.17577C3.23535 4.74315 4.40088 3.57763 5.83301 3.57763H17.002C18.4341 3.57763 19.5996 4.74316 19.5996 6.17577V10.1138C19.5996 10.3901 19.376 10.6138 19.0996 10.6138C18.8233 10.6138 18.5996 10.3901 18.5996 10.1138V6.17577C18.5996 5.29442 17.8828 4.57763 17.002 4.57763H5.83301C4.95215 4.57763 4.23535 5.29443 4.23535 6.17577V19.4023C4.23535 20.2832 4.95215 21 5.83301 21H9.771C10.0474 21 10.271 21.2236 10.271 21.5C10.271 21.7764 10.0474 22 9.771 22Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.4175 6.15527C11.1411 6.15527 10.9175 5.93164 10.9175 5.65527V2.5C10.9175 2.22363 11.1411 2 11.4175 2C11.6939 2 11.9175 2.22363 11.9175 2.5V5.65527C11.9175 5.93164 11.6939 6.15527 11.4175 6.15527Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.75342 6.15527C6.47705 6.15527 6.25342 5.93164 6.25342 5.65527V2.5C6.25342 2.22363 6.47705 2 6.75342 2C7.02979 2 7.25342 2.22363 7.25342 2.5V5.65527C7.25342 5.93164 7.02979 6.15527 6.75342 6.15527Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.0815 6.15527C15.8052 6.15527 15.5815 5.93164 15.5815 5.65527V2.5C15.5815 2.22363 15.8052 2 16.0815 2C16.3579 2 16.5815 2.22363 16.5815 2.5V5.65527C16.5815 5.93164 16.3579 6.15527 16.0815 6.15527Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.0815 10.4765H6.75342C6.47705 10.4765 6.25342 10.2529 6.25342 9.97655C6.25342 9.70018 6.47705 9.47655 6.75342 9.47655H16.0815C16.3579 9.47655 16.5815 9.70018 16.5815 9.97655C16.5815 10.2529 16.3579 10.4765 16.0815 10.4765Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.9898 13.769H6.75342C6.47705 13.769 6.25342 13.5454 6.25342 13.269C6.25342 12.9927 6.47705 12.769 6.75342 12.769H13.9898C14.2661 12.769 14.4898 12.9927 14.4898 13.269C14.4898 13.5454 14.2661 13.769 13.9898 13.769Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.3662 17.0615H6.75342C6.47705 17.0615 6.25342 16.8379 6.25342 16.5615C6.25342 16.2851 6.47705 16.0615 6.75342 16.0615H11.3662C11.6426 16.0615 11.8662 16.2851 11.8662 16.5615C11.8662 16.8379 11.6426 17.0615 11.3662 17.0615Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.686 21.9614C12.5557 21.9614 12.4282 21.9102 12.334 21.8164C12.2134 21.6968 12.1616 21.5244 12.1968 21.3579L12.7319 18.8242C12.752 18.7295 12.7993 18.6426 12.8677 18.5742L16.6641 14.7773C16.8516 14.5898 17.1836 14.5898 17.3711 14.7773L19.3535 16.7602C19.5488 16.9556 19.5488 17.272 19.3535 17.4673L15.5571 21.2637C15.4898 21.3315 15.4038 21.3779 15.3106 21.3984L12.793 21.9497C12.7573 21.9575 12.7217 21.9614 12.686 21.9614ZM13.6797 19.1763L13.335 20.8076L14.9536 20.4531L18.293 17.1138L17.0176 15.8379L13.6797 19.1763Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.9839 17.6299C18.8511 17.6299 18.7241 17.5772 18.6304 17.4834L16.648 15.5005C16.4526 15.3052 16.4526 14.9888 16.648 14.7935L18.3491 13.0923C18.9526 12.4888 19.936 12.4888 20.5396 13.0923L21.0386 13.5913C21.3311 13.8838 21.4922 14.273 21.4922 14.6865C21.4922 15.1006 21.3311 15.4897 21.0386 15.7822L19.3374 17.4834C19.2437 17.5771 19.1167 17.6299 18.9839 17.6299ZM17.7085 15.147L18.9839 16.4228L20.3316 15.0747C20.4351 14.9712 20.4922 14.8335 20.4922 14.6865C20.4922 14.5401 20.4351 14.4019 20.3316 14.2984L19.8325 13.7993C19.6187 13.5855 19.27 13.5855 19.0562 13.7993L17.7085 15.147Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default MyReviewIcon;
